import _ from 'lodash';
import { safeDisplayText, removeHTML } from '../excelCells/cells.config';
export const name = 'EFFICIENCY_SENTENCE.render';
function renderDefault(h, renderOpts, params) {
    const { row, column } = params;
    const prop = _.get(column, 'property');
    const { _highlightMixin_hlText } = renderOpts;
    const cellValue = _.get(row, prop);
    const contentArr = [];
    const sentences = _.map(cellValue, (content) => {
        contentArr.push(removeHTML(content));
        // @ts-ignore
        return <div domProps={{ innerHTML: _highlightMixin_hlText(safeDisplayText(content, 4000)) }}/>;
    });
    const title = contentArr.join('');
    return [
        <div class="xtable-cell-render" cell-type={prop} cell-render={name} style="cursor:pointer" title={title}>
            {sentences}
        </div>,
    ];
}
// 导出模板，例如导出插槽中自定义的内容
function exportMethod(params) {
    const { row, column } = params;
    const result = _.map(row[column.property] || [], item => {
        return item;
    });
    return result.join(',');
}
export default {
    renderDefault,
    exportMethod,
};
